export default "__VITE_ASSET__Djvfd46f__"